import {TombOfAkhenatenReelSymbol} from "./TombOfAkhenatenReelSymbol";
import {
    ISymbolSizeConfig,
    ISymbolStateConfig,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TombOfAkhenatenGameConfig} from "../TombOfAkhenatenGameConfig";
import {TimelineLite} from "gsap";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";

export class TOAScatterSymbol extends TombOfAkhenatenReelSymbol {
    //protected _textImg: PIXI.Sprite | null;
    //protected _gemsImg: PIXI.Sprite | null;

    constructor(symName: string, reelId: number, state?: ISymbolStateConfig, size?: ISymbolSizeConfig) {
        super(symName, reelId, state, size);
    }

    private static symTextPosition(rowCount: number): number {
        let textPos: number = 4;

        switch (rowCount) {
            case 4:
                textPos = -30;
                break;

            case 5:
                textPos = -28;
                break;
        }

        return textPos;
    }

    private static symTextScaling(rowCount: number): number {
        let textScale: number = 1;

        switch (rowCount) {
            case 4:
                textScale = 0.9;
                break;

            case 5:
                textScale = 0.8;
                break;
        }

        return textScale;
    }

    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        let textImg: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this.symName + "/layers/text")[0]);
        textImg.anchor.set(0.5);
        textImg.position.set(0, TOAScatterSymbol.symTextPosition(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN));
        textImg.scale.set(TOAScatterSymbol.symTextScaling(TombOfAkhenatenGameConfig.instance.ACTIVE_ROWS_NEXT_SPIN));
        textImg.name = this.symName + "_textImg";

        let gemsImg: PIXI.Sprite = new PIXI.Sprite(GameResources.getTextures(this.symName + "/layers/gems")[0]);
        gemsImg.anchor.set(0.5);
        gemsImg.name = this.symName + "_gemsImg";

        this.addChild(gemsImg, textImg);
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);
        // if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.idle?.keyword) {
        //     timeline.add(new SpineTween((stateAnimation as any), 0, "bonusIdle", 0), delay);
        //     timeline.add(TweenLite.to(stateAnimation, 0.001, {alpha: 1}), delay);
        //     return;
        // }

        if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            (<PIXI.Sprite[]>this.children).forEach((sprite: PIXI.Sprite) => {

                //below code is for displaying bottom frame & bringing it to top on spin stop
                if (sprite.name && (sprite.name.indexOf("_textImg") > -1)) {
                    this.setChildIndex(sprite, this.children.length - 1);
                }
            });
        }

        /*if (newState.state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            this.children.forEach((sprite: PIXI.Sprite, index: number) => {
                if (sprite.name && sprite.visible) {
                    if ((sprite.name.indexOf("_textImg") > -1) ||
                        (sprite.name.indexOf("_gemsImg") > -1)) {
                        (sprite as PIXI.Sprite).tint = 0x555555;
                    }
                }
            });
        }*/
    }
}